import React from "react";

export default function NoDataPlug({ additionalText }) {
  return (
    <div className="text-center text-base font-medium leading-7 text-gray-900 mt-8">
      Здесь пока еще ничего нет. {additionalText}
    </div>
  );
}
